<template>
    <DModal
        is-error
        is-medium
    >
        <DRow
            v-if="apiError !== null"
            class="w-100 overflow-hidden"
        >
            <h6 class="p-4 ms-3 pb-0 text-danger text-break text-decoration-underline">
                {{ __('settings.check_connection_error_general.titles.api_error') }}
            </h6>
            <DCol padding>
                <p class="p-1 ms-4 text-break">
                    {{ apiError }}
                </p>
            </DCol>
        </DRow>
        <DRow
            v-else
            class="w-100 overflow-hidden"
        >
            <h6 class="p-4 ms-3 pb-0 text-danger text-break text-decoration-underline">
                {{ __('settings.check_connection_error_general.titles.validation_errors') }}
            </h6>
            <DCol padding>
                <ul class="ul-class">
                    <li
                        v-for="(error, index) in validationErrors"
                        :key="index"
                        class="p-1"
                    >
                        {{ error }}
                    </li>
                </ul>
            </DCol>
        </DRow>
        <DRow
            class="w-100 overflow-hidden"
        >
            <p
                v-if="apiError !== null"
                class="p-4 fst-italic text-break"
            >
                {{ __('settings.check_connection_error_general.hint.api_error_text') }}
                <a
                    :href="ticketingUrl"
                    target="_blank"
                >Link</a>
            </p>
            <p
                v-else
                class="p-4 fst-italic text-break"
            >
                {{ __('settings.check_connection_error_general.hint.validation_error_text') }}
                <a
                    :href="ticketingUrl"
                    target="_blank"
                >Link</a>
            </p>
        </DRow>
        <DRow
            v-if="backTrace !== null"
            class="w-100"
        >
            <DButton
                icon="map-legend"
                color="primary"
                :label="__('settings.check_connection_error_general.titles.stack_trace_button')"
                class="mb-3 ms-4 w-25"
                style="justify-content: center;"
                @click="showLegend = !showLegend"
            />
            <DCollapse
                v-show="showLegend"
            >
                <h6 class="p-4 ms-3 pb-0 text-danger text-break text-decoration-underline">
                    {{ __('settings.check_connection_error_general.titles.stack_trace') }}
                </h6>
                <DCol>
                    <p class="p-1 ms-5 text-break">
                        <strong> {{ backTrace }} </strong>
                    </p>
                </DCol>
            </DCollapse>
        </DRow>
    </DModal>
</template>

<script setup>
import { computed, ref } from 'vue'
import { usePage } from '@inertiajs/vue3'

defineProps({
    apiError: {
        type: String,
        default: ''
    },
    validationErrors: {
        type: Object,
        default () {
            return {}
        }
    },
    backTrace: {
        type: String,
        default: ''
    }
})

const ticketingUrl = computed(() => usePage().props.tenantSettings?.internal_support_url)

const showLegend = ref(false)
</script>

<style scoped lang="scss">

</style>
